/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intro_Mode_Classic_DescriptionInputs */

const bn_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কোন জীবন সীমা ছাড়া স্ট্যান্ডার্ড স্কোরিং.`)
};

const de_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standardwertung ohne Lebenslimit.`)
};

const el_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τυπική βαθμολογία χωρίς όριο ζωής.`)
};

const en_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard scoring with no life limit.`)
};

const es_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puntuación estándar sin límite de vida.`)
};

const fr_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Score standard sans limite de vies.`)
};

const hi_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बिना किसी जीवन सीमा के मानक स्कोरिंग।`)
};

const hu_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normál pontozás élettartamkorlát nélkül.`)
};

const id_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penilaian standar tanpa batas hidup.`)
};

const it_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punteggio standard senza limiti di vita.`)
};

const ja_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライフ制限のない標準スコア。`)
};

const ko_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수명 제한이 없는 표준 점수입니다.`)
};

const nl_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standaardscore zonder levenslimiet.`)
};

const pl_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standardowa punktacja bez limitu życia.`)
};

const pt_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pontuação padrão sem limite de vida.`)
};

const ru_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стандартный подсчет очков без ограничения срока жизни.`)
};

const sv_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standardpoäng utan livslängd.`)
};

const tr_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yaşam sınırı olmayan standart puanlama.`)
};

const uk_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стандартна оцінка без обмеження життя.`)
};

const vi_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tính điểm tiêu chuẩn không có giới hạn cuộc sống.`)
};

const zh_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标准评分，无生命限制。`)
};

const zh_hant_intro_mode_classic_description = /** @type {(inputs: Intro_Mode_Classic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準評分，無生命限制。`)
};

/**
* | output |
* | --- |
* | "Standard scoring with no life limit." |
*
* @param {Intro_Mode_Classic_DescriptionInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const intro_mode_classic_description = /** @type {((inputs?: Intro_Mode_Classic_DescriptionInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intro_Mode_Classic_DescriptionInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_intro_mode_classic_description(inputs)
	if (locale === "de") return de_intro_mode_classic_description(inputs)
	if (locale === "el") return el_intro_mode_classic_description(inputs)
	if (locale === "en") return en_intro_mode_classic_description(inputs)
	if (locale === "es") return es_intro_mode_classic_description(inputs)
	if (locale === "fr") return fr_intro_mode_classic_description(inputs)
	if (locale === "hi") return hi_intro_mode_classic_description(inputs)
	if (locale === "hu") return hu_intro_mode_classic_description(inputs)
	if (locale === "id") return id_intro_mode_classic_description(inputs)
	if (locale === "it") return it_intro_mode_classic_description(inputs)
	if (locale === "ja") return ja_intro_mode_classic_description(inputs)
	if (locale === "ko") return ko_intro_mode_classic_description(inputs)
	if (locale === "nl") return nl_intro_mode_classic_description(inputs)
	if (locale === "pl") return pl_intro_mode_classic_description(inputs)
	if (locale === "pt") return pt_intro_mode_classic_description(inputs)
	if (locale === "ru") return ru_intro_mode_classic_description(inputs)
	if (locale === "sv") return sv_intro_mode_classic_description(inputs)
	if (locale === "tr") return tr_intro_mode_classic_description(inputs)
	if (locale === "uk") return uk_intro_mode_classic_description(inputs)
	if (locale === "vi") return vi_intro_mode_classic_description(inputs)
	if (locale === "zh") return zh_intro_mode_classic_description(inputs)
	return zh_hant_intro_mode_classic_description(inputs)
});